'use strict';

var reactIs_development = {};

exports.__exports = reactIs_development;
//# sourceMappingURL=react-is.development2.cjs.map
